import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import WhereToFind from './pages/WhereToFind';
import logo from './assets/logo.jpg';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="header">
          <div className="container">
            <div className="logo-container">
              <img src={logo} alt="Maia&Ostara Logo" className="logo-image" />
              <h1 className="logo">Maia&Ostara</h1>
            </div>
            <nav className="nav">
              <Link to="/" className="nav-link">Accueil</Link>
              <Link to="/produits" className="nav-link">Produits</Link>
              <Link to="/qui-suis-je" className="nav-link">Qui suis-je</Link>
              <Link to="/ou-me-trouver" className="nav-link">Où me trouver</Link>
            </nav>
          </div>
        </header>
        
        <main className="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produits" element={<Products />} />
            <Route path="/qui-suis-je" element={<About />} />
            <Route path="/ou-me-trouver" element={<WhereToFind />} />
          </Routes>
        </main>
        
        <footer className="footer">
          <div className="container">
            <p>&copy; 2026 Maia&Ostara - Vêtements uniques faits à la main en France</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
